module.exports = __webpack_public_path__ + "img/calendar-active.68da3856.svg";